import { render } from "./BoiteDesCouleurs1.vue?vue&type=template&id=f1da01ec"
import script from "./BoiteDesCouleurs1.vue?vue&type=script&lang=js"
export * from "./BoiteDesCouleurs1.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__